import $ from 'jquery';

window.addEventListener('load', function() {

  var news_list = document.querySelector('.js-news-list');

  if(!news_list)
    return;

  window.paged = 2;
  var maxnumpages = document.querySelector('.js-list-news-item').getAttribute('data-maxnumpages');
  var select = document.querySelector('select');
  var loadMoreButton = document.querySelector('.js-load-more-news');

  // Load News on Page Init
  loadNews();

  // On filters change, empty List & load a new List
  select.addEventListener('change', function(){
    news_list.classList.add('loading');
    news_list.innerHTML = '';
    window.paged = 1;
    loadMoreButton.style.display = "none";
    loadNews();
  });

  // On Load More Click, Show n+1 Page and Load hidden n+2 Page
  loadMoreButton.addEventListener('click', function(){

    // Disabled during ajax load
    if(loadMoreButton.classList.contains('disabled'))
      return;

    window.paged++;
    loadNews();
  });

  // Show previous Page & Load hidden next Page with filters
  function loadNews(){

    // Display previous Pages
    var newsItems = document.querySelectorAll('.js-list-news-item');
    Array.prototype.forEach.call(newsItems, function(el){
      el.classList.remove('visually-hidden');
    });

    // Disable loadMoreButton during ajax load
    loadMoreButton.classList.add('disabled');
    // Hide loadMoreButton & break function when there's no more Page to load
    if(window.paged > maxnumpages){
      loadMoreButton.style.display = 'none';
      return;
    }

    // Ajax Post
    $.ajax({
      cache: true,
      url: ajaxurl,
      type: 'get',
      data: {
        action: 'load_news',
        paged: window.paged,
        departement: document.querySelector('select#select_departement').value,
      },
      success: function(html) {
        if(html){

          // Add page results to list
          news_list.innerHTML += html;
          news_list.classList.remove('loading');

          // On 1st page, set maxnumpage and load an hidden 2nd page
          if(window.paged == 1){
            maxnumpages = document.querySelector('.js-list-news-item').getAttribute('data-maxnumpages');
            window.paged++;
            loadNews();
          }

          if(window.paged <= maxnumpages){
            loadMoreButton.style.display = 'inline-flex';
          }

          // Enable loadMoreButton after ajax load
          loadMoreButton.classList.remove('disabled');
        }
      }
    });
  }

});



// prop button
